import { motion } from 'framer-motion';

interface AuthorityBadgeProps {
  lastUpdated: string;
  researchInitiative: string;
  sourceCount: number;
  domain: string;
}

export function AuthorityBadge({ lastUpdated, researchInitiative, sourceCount, domain }: AuthorityBadgeProps) {
  return (
    <motion.div
      className="flex flex-wrap gap-3 items-center text-xs sm:text-sm text-slate-500 dark:text-slate-400 mb-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3 }}
      data-domain={domain}
    >
      <span className="flex items-center gap-1">
        Last Updated: {lastUpdated}
      </span>
      <span className="hidden sm:inline text-slate-300 dark:text-slate-600">|</span>
      <span className="flex items-center gap-1">
        {researchInitiative}
      </span>
      <span className="hidden sm:inline text-slate-300 dark:text-slate-600">|</span>
      <span className="flex items-center gap-1">
        {sourceCount} Scholarly Sources
      </span>
    </motion.div>
  );
}
